import { IntlMessageFormat } from 'intl-messageformat';
import { useLocale } from 'next-intl';
import { getLocale } from 'next-intl/server';
import { useCallback } from 'react';

import { mapOptimizelyLocaleToIntlLocale } from './map-optimizely-locale-to-intl-locale';

const DOUBLE_BRACE_PLACEHOLDER_PATTERN = /\{\{(\w+)\}\}/gu;

const normalizeDoubleBracePlaceholders = (message: string) =>
  message.replaceAll(DOUBLE_BRACE_PLACEHOLDER_PATTERN, '{$1}');

const formatTranslation = (
  message: string,
  locale: string,
  values: Record<string, boolean | Date | null | number | string | undefined> | undefined
) => {
  try {
    return new IntlMessageFormat(normalizeDoubleBracePlaceholders(message), locale).format(
      values
    ) as string;
  } catch {
    return message;
  }
};

export const formatTranslationString = async (
  message: string,
  values: Record<string, boolean | Date | null | number | string | undefined> | undefined
) => {
  const intlLocale = mapOptimizelyLocaleToIntlLocale(await getLocale()); // todo this conversion is necessary only until MDRT center will update local handling

  return formatTranslation(message, intlLocale || 'en-US', values);
};

export const useFormatTranslationString = () => {
  const optimizelyLocale = useLocale();
  const intlLocale = mapOptimizelyLocaleToIntlLocale(optimizelyLocale); // todo this conversion is necessary only until MDRT center will update local handling

  return useCallback(
    (
      message: string,
      values: Record<string, boolean | Date | null | number | string | undefined> | undefined
    ) => formatTranslation(message, intlLocale || 'en-US', values),
    [intlLocale]
  );
};
